import {
  ModalActionDef,
  ModalDefine,
  ModalStatus
} from '@/libs/formHelper/modalForm/type'
import { Donation } from '@/api/donation/Donation'

export default function getModalDefine (view: any): ModalDefine<Donation> {
  const items = [
    {
      title: '村庄名称',
      col: { span: 12 },
      required: true,
      key: 'name',
      type: {
        module: 'text',
        maxlength: 10
      }
    },
    {
      title: '省市区',
      col: { span: 12 },
      required: true,
      key: 'address',
      slot: 'address'
    },
    {
      title: '详细地址',
      col: { span: 24 },
      required: true,
      key: 'address',
      type: {
        module: 'textarea',
        limit: 50
      }
    }
  ]

  const actions: ModalActionDef<Donation>[] = [
    {
      key: 'create',
      title: '创建',
      type: 'submit',
      button: 'success',
      actionClose: true,
      modalStatus: ModalStatus.ADD,
      onClick: (item: Donation) => {
        return view.onInsertItem(item)
      }
    },
    {
      key: 'modi',
      title: '保存',
      type: 'submit',
      button: 'success',
      actionClose: true,
      modalStatus: ModalStatus.MODI,
      onClick: (item: Donation) => {
        return view.onUpdateItem(item)
      }
    }
  ]

  return {
    items,
    actions
  }
}
